import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, credentials);
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminUsername", response.data.username);
      navigate("/admin/dashboard");
    } catch (error) {
      console.error("Login error:", error);
      alert("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-brand-50 to-white flex items-center justify-center py-12 px-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full border-t-4 border-brand-500">
        <h1 className="text-3xl font-bold text-gray-900 mb-2 text-center" data-testid="admin-login-title">
          Admin Login
        </h1>
        <p className="text-gray-600 text-center mb-8">99prop.com Administration</p>

        <form onSubmit={handleLogin} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Username</label>
            <input
              type="text"
              required
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-brand-500 focus:outline-none"
              data-testid="admin-username"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
            <input
              type="password"
              required
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-brand-500 focus:outline-none"
              data-testid="admin-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-brand-500 text-white py-3 px-6 rounded-lg font-bold hover:bg-brand-600 transition disabled:bg-gray-400"
            data-testid="admin-login-btn"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

// ==================== ADMIN DASHBOARD ====================

export default AdminLoginPage;
